import { ScrollView, StyleSheet } from 'react-native';
import { Text, VStack } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';
import type { AgentToolAction } from '../types';
import { ToolActionApprovalCard } from './ToolActionApprovalCard';

interface ToolActionFeedProps {
  actions: AgentToolAction[];
  onApprove?: (actionId: string) => void;
  onReject?: (actionId: string) => void;
  isApproving?: boolean;
  isRejecting?: boolean;
}

export function ToolActionFeed({
  actions,
  onApprove,
  onReject,
  isApproving,
  isRejecting,
}: Readonly<ToolActionFeedProps>) {
  const { t } = useTranslation();

  if (actions.length === 0) {
    return (
      <Text variant="caption" color={colors.text.tertiary} style={styles.empty}>
        {t('agents.toolActions.noActions')}
      </Text>
    );
  }

  return (
    <ScrollView
      style={styles.scrollView}
      contentContainerStyle={styles.content}
      showsVerticalScrollIndicator={false}
    >
      <VStack spacing="sm">
        {actions.map((action) => (
          <ToolActionApprovalCard
            key={action.id}
            action={action}
            onApprove={onApprove}
            onReject={onReject}
            isApproving={isApproving}
            isRejecting={isRejecting}
          />
        ))}
      </VStack>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    maxHeight: 300,
  },
  content: {
    paddingVertical: tokens.spacing.xs,
  },
  empty: {
    textAlign: 'center',
    paddingVertical: tokens.spacing.lg,
  },
});
